import axios from "axios";
import Cookies from "universal-cookie";
import { OFFERWALL_API } from "../utils/env";

const cookies = new Cookies();

const refreshToken = async () => {
    try {
        const res = await offerwallauthapi.post("/clients/clientrefresh");
        return res.data;
    } catch (err) { }
};

const offerwallauthapi = axios.create({
    baseURL: OFFERWALL_API,
    withCredentials: true,
});

const offerwallapi = axios.create({
    baseURL: OFFERWALL_API,
    withCredentials: true,
});

offerwallapi.interceptors.request.use(
    async (config) => {
        // if (cookies.get("rtid")) {
        //     await refreshToken();
        // }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
offerwallapi.interceptors.response.use(function (response) {
    return response;
}, async function (error) {
    if (error.response.status === 403 || error.response.status === 401) {
        // Check if we're in the middle of a card enrollment flow
        // Don't clear cookies immediately as they might still be loading after redirect
        const urlParams = new URLSearchParams(window.location.search);
        const isCardAddFlow = urlParams.has('info');
        
        if (isCardAddFlow) {
            console.log(
                'API Service - Card enrollment flow detected, preserving cookies and retrying'
            );
            // Wait a bit for cookies to be available, then retry the request
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // Check if cookie is now available
            const cookieCheck = cookies.get("ow-c");
            if (cookieCheck) {
                console.log('API Service - Cookie found after delay, retrying request');
                return offerwallapi(error.config);
            }
        }
        
        // User was anonymous or cookie still not available, redirect to auth
        const loc = window.location.pathname;
        const tenanturl = loc.split("/")[1];
        console.log(
            'API Service - Redirecting to auth, clearing stale cookies'
        );
        // localStorage.removeItem("c");
        cookies.remove("ow-c");
        window.location.replace("/" + tenanturl + "/auth");
        // Return a never-resolving promise so calling code doesn't proceed
        // (page is navigating away — prevents catch blocks from firing navigate("/"))
        return new Promise(() => {});

    } else {
        return Promise.reject(error);
    }
});

export { offerwallapi, offerwallauthapi }